import type { JobFamily, PostedWithin, Seniority, WorkSetting } from "@/lib/api/catalogue";

/**
 * The words for the catalogue's own values: work settings, posting
 * windows, levels and families. Pure.
 */

export const WORK_SETTING_LABEL: Record<WorkSetting, string> = {
    REMOTE: "Remote",
    HYBRID: "Hybrid",
    ON_SITE: "On-site",
};

export const WORK_SETTINGS: readonly WorkSetting[] = ["REMOTE", "HYBRID", "ON_SITE"];

export const POSTED_LABEL: Record<PostedWithin, string> = {
    "24h": "24 h",
    "3d": "3 days",
    "7d": "7 days",
};

export const POSTED_WINDOWS: readonly PostedWithin[] = ["24h", "3d", "7d"];

export const SENIORITY_LABEL: Record<Seniority, string> = {
    INTERNSHIP: "Internship",
    ENTRY: "Entry",
    MID: "Mid",
    SENIOR: "Senior",
    LEAD: "Lead",
    MANAGER: "Manager",
    DIRECTOR: "Director",
    EXECUTIVE: "Executive",
};

export const FAMILY_LABEL: Record<JobFamily, string> = {
    SOFTWARE_ENGINEERING: "Software engineering",
    DATA_AND_ANALYTICS: "Data and analytics",
    IT_AND_INFRASTRUCTURE: "IT and infrastructure",
    SECURITY: "Security",
    PRODUCT_MANAGEMENT: "Product management",
    DESIGN: "Design",
    PROJECT_AND_PROGRAM_MANAGEMENT: "Project and program management",
    SALES: "Sales",
    MARKETING: "Marketing",
    CUSTOMER_SUPPORT_AND_SUCCESS: "Customer support and success",
    FINANCE_AND_ACCOUNTING: "Finance and accounting",
    PEOPLE_AND_RECRUITING: "People and recruiting",
    LEGAL_AND_COMPLIANCE: "Legal and compliance",
    OPERATIONS_AND_ADMINISTRATION: "Operations and administration",
    SUPPLY_CHAIN_AND_LOGISTICS: "Supply chain and logistics",
    MANUFACTURING_AND_PRODUCTION: "Manufacturing and production",
    SKILLED_TRADES: "Skilled trades",
    ENGINEERING: "Engineering",
    SCIENCE_AND_RESEARCH: "Science and research",
    NURSING: "Nursing",
    HEALTHCARE: "Healthcare",
    EDUCATION_AND_TRAINING: "Education and training",
    HOSPITALITY_AND_FOOD_SERVICE: "Hospitality and food service",
    RETAIL: "Retail",
    MEDIA_AND_COMMUNICATIONS: "Media and communications",
    OTHER: "Other",
};
